var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10ZM9.385 8.6375C9.41109 8.4934 9.48696 8.36303 9.59936 8.26916C9.71176 8.17528 9.85355 8.12386 10 8.12386C10.1464 8.12386 10.2882 8.17528 10.4006 8.26916C10.513 8.36303 10.5889 8.4934 10.615 8.6375L10.625 8.75V14.3775L10.615 14.49C10.5889 14.6341 10.513 14.7645 10.4006 14.8583C10.2882 14.9522 10.1464 15.0036 10 15.0036C9.85355 15.0036 9.71176 14.9522 9.59936 14.8583C9.48696 14.7645 9.41109 14.6341 9.385 14.49L9.375 14.3775V8.75L9.385 8.6375ZM9.0625 5.9375C9.0625 5.68886 9.16127 5.4504 9.33709 5.27459C9.5129 5.09877 9.75136 5 10 5C10.2486 5 10.4871 5.09877 10.6629 5.27459C10.8387 5.4504 10.9375 5.68886 10.9375 5.9375C10.9375 6.18614 10.8387 6.4246 10.6629 6.60041C10.4871 6.77623 10.2486 6.875 10 6.875C9.75136 6.875 9.5129 6.77623 9.33709 6.60041C9.16127 6.4246 9.0625 6.18614 9.0625 5.9375Z",
    fill: "#F2994A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.85059c7341ffa2ca377c5568b6b3744e.svg";
export { ForwardRef as ReactComponent };